import { LocalStorage } from 'libs/storage/LocalStorage';
export const STORE_CART_TTL_MS = 30 * 24 * 60 * 60 * 1000;
/**
 * Temporary kill-switch: localStorage cart restore was causing stale Deal
 * loads and checkout resume issues. Re-enable when persistence is needed again.
 */
const STORE_CART_PERSISTENCE_ENABLED = false;
function storageKey(host) {
    return `store.cart.${host}`;
}
function isSelectedItem(value) {
    if (value == null || typeof value !== 'object') {
        return false;
    }
    const item = value;
    return (typeof item.id === 'string' &&
        typeof item.quantity === 'number' &&
        Array.isArray(item.selectedOptionIds) &&
        item.selectedOptionIds.every((id) => typeof id === 'string') &&
        (item.optionQuantities == null || typeof item.optionQuantities === 'object'));
}
/**
 * Restores the browser-local store cart (selection + open Deal id).
 */
export function loadStoreCart(host) {
    if (!STORE_CART_PERSISTENCE_ENABLED) {
        clearStoreCart(host);
        return null;
    }
    try {
        const stored = LocalStorage.get(storageKey(host));
        if (stored == null || typeof stored !== 'object') {
            return null;
        }
        if (typeof stored.savedAt !== 'number') {
            return null;
        }
        if (Date.now() - stored.savedAt > STORE_CART_TTL_MS) {
            clearStoreCart(host);
            return null;
        }
        const items = Array.isArray(stored.items)
            ? stored.items.filter(isSelectedItem)
            : [];
        const dealId = typeof stored.dealId === 'string' && stored.dealId.length > 0
            ? stored.dealId
            : null;
        if (!dealId && items.length === 0) {
            return null;
        }
        return {
            dealId,
            items,
            savedAt: stored.savedAt
        };
    }
    catch (_a) {
        return null;
    }
}
/**
 * Persists the current store selection and Deal id for the same browser.
 */
export function saveStoreCart(host, state) {
    if (!STORE_CART_PERSISTENCE_ENABLED) {
        return;
    }
    if (!state.dealId && state.items.length === 0) {
        clearStoreCart(host);
        return;
    }
    LocalStorage.set(storageKey(host), {
        dealId: state.dealId,
        items: state.items,
        savedAt: Date.now()
    });
}
export function clearStoreCart(host) {
    LocalStorage.set(storageKey(host), null);
}
/**
 * Maps an open Deal back to the store product selection. The saved option
 * quantities are kept: they only count for the options whose quantity the
 * customer picks.
 */
export function selectedItemsFromDeal(deal) {
    var _a;
    return ((_a = deal.items) !== null && _a !== void 0 ? _a : [])
        .filter((item) => !item.proposed)
        .map((item) => {
        var _a, _b;
        const extras = (_b = (_a = item.options) === null || _a === void 0 ? void 0 : _a.filter((option) => {
            var _a;
            return !option.included &&
                !option.proposed &&
                typeof ((_a = option.item) === null || _a === void 0 ? void 0 : _a.id) === 'string';
        })) !== null && _b !== void 0 ? _b : [];
        return {
            id: item.item.id,
            quantity: item.quantity,
            selectedOptionIds: extras.map((option) => option.item.id),
            optionQuantities: Object.fromEntries(extras.map((option) => [option.item.id, option.quantity]))
        };
    });
}
export function readInitialStoreCart(urlDealId) {
    var _a, _b;
    const persisted = loadStoreCart(window.location.hostname);
    if (!STORE_CART_PERSISTENCE_ENABLED) {
        return { dealId: urlDealId, items: [] };
    }
    if (urlDealId && (persisted === null || persisted === void 0 ? void 0 : persisted.dealId) && urlDealId !== persisted.dealId) {
        return { dealId: urlDealId, items: [] };
    }
    return {
        dealId: (_a = urlDealId !== null && urlDealId !== void 0 ? urlDealId : persisted === null || persisted === void 0 ? void 0 : persisted.dealId) !== null && _a !== void 0 ? _a : null,
        items: (_b = persisted === null || persisted === void 0 ? void 0 : persisted.items) !== null && _b !== void 0 ? _b : []
    };
}
